// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"b78096b5","145":"e4889c6a","246":"1f74f59f","288":"4bdc84eb","384":"6f839dba","624":"ae632af5","648":"7027bcb5","834":"48281151","965":"b05cfdf4"}[chunkId] + ".css";
};